import type { StateCreator } from "zustand";

export interface FocusSlice {
    /** Panel id → the stream its legend has focused. Absent means nothing is focused. */
    focusedStreams: Record<string, number>;
    setFocusedStream: (panelId: string, streamId: number | null) => void;
}

export const createFocusSlice: StateCreator<FocusSlice, [], [], FocusSlice> = (set) => ({
    focusedStreams: {},
    setFocusedStream: (panelId, streamId) =>
        set((state) => {
            const { [panelId]: _previous, ...others } = state.focusedStreams;
            return { focusedStreams: streamId === null ? others : { ...others, [panelId]: streamId } };
        }),
});
